import beaconReport from '@utils/beacon';
import { useState, useCallback, useEffect } from 'react';
import useStorage, { useStorageArr } from 'src/hooks/useStorage';

export interface IProps {
  isSubscribed?: boolean;
  className?: string;
  hostId?: string | number;
  toggleSubscribe: (doSubscribe: any, callback?: (isSubscribe?: boolean) => void) => void;
}

const useFollowGuide = (props: IProps) => {
  const { hostId, toggleSubscribe } = props;
  const [noRemindAll, setNoRemindAll] = useStorage('no_remind.all', false);
  const [noRemindList, setNoRemindList] = useStorageArr<string>('no_remind.id', []);
  const [visible, setVisible] = useState<boolean>(false);

  const handleNoRemind = useCallback(() => {
    setVisible(false);
    setNoRemindAll(true);
    beaconReport('eventproduct_personalstation_follow_hintoperation_null_null_click', {
      hostid: hostId,
      operation: 'noalarm',
    });
  }, [hostId]);

  const handleKnowBtn = useCallback(() => {
    setVisible(false);
    setNoRemindList(String(hostId));
    beaconReport('eventproduct_personalstation_follow_hintoperation_null_null_click', {
      hostid: hostId,
      operation: 'known',
    });
  }, [hostId]);

  const bubbleVisible = visible && !noRemindAll && !noRemindList.includes(String(hostId));

  const onSubscribe = useCallback(() => {
    toggleSubscribe(null, (nextState) => {
      if (nextState) {
        setVisible(true);
      }
    });
  }, [toggleSubscribe]);

  const justHide = useCallback(() => setVisible(false), []);

  useEffect(() => {
    if (!bubbleVisible) return;
    beaconReport('eventproduct_personalstation_follow_hint_null_null_explore', { hostid: hostId });
  }, [bubbleVisible, hostId]);

  // 1分钟后自动关闭,仅本次隐藏
  useEffect(() => {
    if (!bubbleVisible) return;
    const t = setTimeout(() => {
      setVisible(false);
    }, 60000);
    return () => clearTimeout(t);
  }, [bubbleVisible]);

  return {
    /** 气泡是否可见 */
    bubbleVisible,
    /** 用户点击关注时 */
    onSubscribe,
    /** 不再提示此ID */
    handleKnowBtn,
    /** 不再提示任何ID */
    handleNoRemind,
    /** 仅隐藏 */
    justHide,
  };
};

export default useFollowGuide;
